<template>
  <div id="summary" class="card card-body">
    <div class="row align-items-center ms-0">
      <article-image-upload
        ref="imageUploadRef"
        :url="visualImage"
        @updated="onImageUpdated"
      />
      
      <div class="col">
        <h5 class="mb-1 font-weight-bolder">
          {{ title }}
        </h5>

        <p class="mb-0 font-weight-normal text-sm">
          {{ venueName }}

          <template v-if="venueName && parsedDateTimeRange">
            //
          </template>

          {{ dateString }} // {{ timeString }}
        </p>
      </div>

      <div class="user-selector-dropdown">
        <author-select-dropdown 
          v-model="authorIdHandler"
          :enabled="!showUpdate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AuthorSelectDropdown from '@/components/Shared/AuthorSelectDropdown/AuthorSelectDropdown.vue';
import ArticleImageUpload from '@/components/Shared/ArticleImageUpload/ArticleImageUpload.vue';
import { parseDateTimeRange } from '@/helpers/parsers';
import { getDateString, getTimeString } from '@/helpers/datetime';

export default {
  components: {
    ArticleImageUpload,
    AuthorSelectDropdown,
  },

  props: {
    showUpdate: {
      type: Boolean,
      default: true,
    },
    createdDateTime: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true,
    },
    visualImage: {
      type: String,
      required: true,
    },
    visualImageData: {
      type: String,
      default: '',
    },
    authorId: { 
      type: [Number, null],
      default: null,
    }
  },

  emits: [
    'update:visualImage',
    'update:visualImageData',
    'update:authorId'
  ],

  computed: {
    dateString() {
      const dateString = getDateString(new Date(this.createdDateTime));
      return dateString !== '' ? dateString : 'Datum';
    },

    timeString() {
      const timeString = getTimeString(new Date(this.createdDateTime));
      return timeString !== '' ? timeString : 'Tijd';
    },

    authorIdHandler: {
      get() { return this.authorId; },
      set(v) { this.$emit('update:authorId', v) }
    }
  },

  methods: {
    parseDateTimeRange,

    visualImageChanged({ target }) {
      const reader = new FileReader();
      reader.onload = ({ target }) => {
        this.$emit('update:visualImageData', target.result);
      };
      reader.readAsDataURL(target.files[0]);
    },

    removevisualImage() {
      if (!confirm('Weet je zeker dat je de afbeelding wil verwijderen?')) {
        return;
      }

      this.$emit('update:visualImage', '');
      this.$emit('update:visualImageData', '');
    },

    onImageUpdated(data) {
      this.$emit('update:visualImageData', data);
    }
  },
};
</script>

<style scoped lang="scss">
.summary {
  &__image {
  
    &-column {
      width: 120px;
    }
  }
}

.summary-visual {
  &__image {
    aspect-ratio: 1;
    object-fit: cover;
  }

  &-remove {
    transition: opacity .2s;

    &:not(:hover) {
      opacity: 0;
    }

    &__background {
      opacity: .75;
    }
  }
}

.user-selector-dropdown {
  float:right;

  width:250px;
  .user-profile-image {
    margin-left: -3px;
  }
}
</style>
